import { useMemo } from 'react'

import config from 'constants/config'
import { destinationsMap, EXPERIENCE_DESTINATION, type ExperienceBrandDestination } from 'constants/experience'
import { useLocalizedPlaces } from 'hooks/usePlace'

interface ResolvedExperienceBrandDestination extends ExperienceBrandDestination {
  name?: string
  loading: boolean
}

export function useExperienceBrandDestinations(): Array<ResolvedExperienceBrandDestination> {
  const destinations = destinationsMap(config.BRAND)
  const placeIds = useMemo(() => destinations.map((destination) => destination.id), [destinations])
  const localizedPlaces = useLocalizedPlaces(placeIds)

  return useMemo(() => destinations.map((destination) => {
    const localized = localizedPlaces[destination.id]
    const loading = localized?.isLoading ?? true

    return {
      ...destination,
      name: localized?.place?.name,
      loading,
    }
  }), [destinations, localizedPlaces])
}

export function useExperienceBrandDestinationNames(): Array<string> {
  const destinations = useExperienceBrandDestinations()
  return useMemo(
    () => destinations
      .filter((destination): destination is ResolvedExperienceBrandDestination & { name: string } =>
        destination.destinationKey !== EXPERIENCE_DESTINATION.ANYWHERE && !!destination.name,
      )
      .map((destination) => destination.name),
    [destinations],
  )
}
